import { createFileRoute } from '@tanstack/react-router'
import Hero from '../components/features/sections/Hero'
import Services from '../components/features/sections/Services'
import Testimonials from '../components/features/sections/Testimonials'
import FeaturedBooks from '../components/features/sections/FeaturedBooks'
import { EditorList } from '../components/features/sections/EditorList'
import { getFeaturedProducts } from '../lib/data/products'

// Helper to generate placeholder
function generatePlaceholderDataURI(width: number, height: number): string {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}'%3E%3Crect width='${width}' height='${height}' fill='%23e2e8f0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='14' fill='%2394a3b8'%3ENo Image%3C/text%3E%3C/svg%3E`
}

interface Book {
  id: string
  title: string
  slug: string
  author: string
  price: number
  originalPrice?: number
  coverImage: string
  category: string
  rating?: number
  isNew?: boolean
}

export const Route = createFileRoute('/')({
  component: Home,
  loader: async () => {
    const featuredProducts = getFeaturedProducts(12)
    
    const featuredBooks: Book[] = featuredProducts.map((book) => ({
      id: String(book.id),
      title: book.title,
      slug: book.slug,
      author: book.author || 'Unknown',
      price: book.price || 0,
      originalPrice: book.salePrice && book.price ? book.price : undefined,
      coverImage: book.mediaCover?.url || book.coverImage || generatePlaceholderDataURI(300, 400),
      category: book.categories?.[0]?.category?.name || 'Umum',
      rating: book.rating || 0,
      isNew: book.createdAt ? new Date(book.createdAt) > new Date(Date.now() - 30 * 24 * 60 * 60 * 1000) : false,
    }))
    
    return { featuredBooks }
  },
})

function Home() {
  const { featuredBooks } = Route.useLoaderData()

  return (
    <div>
      <Hero />
      <FeaturedBooks books={featuredBooks} />
      <Services />
      <EditorList />
      <Testimonials />
    </div>
  )
}
